export default __webpack_public_path__ + "static/media/City_sunset.b49192a1.jpg";